<script setup lang="ts">
import {useI18n} from "vue-i18n";
import {onBeforeMount} from "vue";
import {trackData} from "@Helpers/trackData";
import trackingEvents from "@Helpers/trackingEvents.json";

const {t} = useI18n();
onBeforeMount(() => {
    trackData({
        event: trackingEvents.BILLING_TIP_HELP_CLICKED
    });
});
</script>
<template>
    <div class="tip-explanation">
        <h3>{{ t('cms.modules.payment_tip.explain_title') }}</h3>
        <p>
            <strong><a :href="t('cms.modules.payment_tip.explain_link_yapla')" target="_blank">Yapla</a></strong>
            {{ t('cms.modules.payment_tip.explain_link_yapla_label') }}
        </p>
        <p v-html="t('cms.modules.payment_tip.explain_why_needs_tip')"/>
        <p v-if="t('cms.modules.payment_tip.explain_why_needs_tip_last') !== ''">
            <strong>
                {{ t('cms.modules.payment_tip.explain_why_needs_tip_last') }}
            </strong>
        </p>
    </div>
</template>
<style scoped>
.tip-explanation {
    margin: 2rem 0;

    h3, p {
        text-transform: none;
        margin-bottom: 3rem;
    }
}
</style>
